<script>
    import { auth, signIn, passwordReset } from '../firebase';

    function signInButton() {
        var email = document.getElementById("email").value;
        var password = document.getElementById("password").value;

        signIn(auth, email, password);

    }

    function forgotPasswordButton() {
        passwordReset(auth);
    }
</script>

<div class="signin-container">
    <div class="box mt-6 mb-6">
        <h3 class="is-size-3 mb-3">Welcome back!</h3>
        <div class="field">
            <label class="label">Email Address</label>
            <div class="control">
                <input id="email" class="input" type="email" placeholder="e.g. you@example.com">
            </div>
        </div>
        <div class="field">
            <label class="label">Password</label>
            <div class="control">
                <input id="password" class="input" type="password" placeholder="...">
            </div>
        </div>
        <div class="control">
            <button class="button is-dark" type="button" on:click={signInButton}>Sign in</button>
        </div>
        <br>
        <div class="control">
            <button class="button is-light" type="button" on:click={forgotPasswordButton}>Forgot Password?</button>
        </div>
    </div>  
</div>

<style>
    .signin-container {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

</style>